<template>
  <div class="alipaywrapy">
    <search></search>
    <div class="alipay">
      <div class="paysuccessBox">
        <div class="paysuccessMain">
          <p class="successtxt"><span class="successicon"><img :src="successimg"/></span><span class="successt">您已成功付款</span></p>
        </div>
        <div class="paysuccessTitle">
          <div class="successAddress">
            <span>收货地址：</span><span>{{successAddress}}</span>
          </div>
          <div class="successPrice">
            <span>实付金额：</span><span>{{successPrice}}</span>
          </div>

        </div>
        <div class="paysuccessFooter">
          <div class="gohome"><router-link tag="a" target="_blank" :to="{name:'hpme'}">返回首页</router-link></div><div>|</div><div class="gogoodsdetails" :data_id="orderId">返回订单详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import Qs from 'qs'
    import { ip,sha1,overtime } from '../../assets/js/public.js'
    import search from '@/components/index/search'
    export default {
        name: "alipay",
        data () {
          return {
            successimg:"",
            areaid:2,
            credentials:"",
            successAddress:"",
            successPrice:"",
            orderId:""
          }
        },
        components:{
          search
        },
        mounted () {
          this.credentials = this.$route.query.out_trade_no;
          this.payment()
        },
        methods:{
          payment:function(){
            const url = `${ip}formWorkInterface/payment`;
            let data = Qs.stringify({"channel":this.areaid,outTradeNo:this.credentials,tamp:localStorage.tamp?localStorage.tamp:''});
            axios.post(url,data)
              .then(res => {
                if(overtime(res.data.code)){
                  localStorage.removeItem('tamp')
                  localStorage.removeItem('name')
                  return this.$router.push({
                    path: '/LoginHome?state=1',
                    query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
                  });
                  this.$router.go(0);
                }
                if(res.data.code==300){
                  var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
                  return window.open(href.href,'_blank')
                }
                if(res.data.code == 0){
                  if(res.data.data.length == 0 || res.data.data.length == "0" ){
                    alert("服务器繁忙！请返回订单详情查看！")
                  }else {
                    //状态返回2支付成功！
                    if(res.data.data.status == 2 || res.data.data.status == "2"){
                      this.successimg = require("../../assets/img/success.png")
                      this.successAddress = res.data.data.address + "" + res.data.data.recipient + "" + res.data.data.mobilePhone;
                      this.successPrice = res.data.data.price;
                      this.orderId = res.data.data.id
                      //状态返回2支付失败！
                    }else if(res.data.data.status == 1 || res.data.data.status == "1"){
                      this.successimg = require("../../assets/img/error.png")
                    }
                  }
                }else if(res.data.code==-550){
                  this.payment()
                }

              }).catch(err => {
            })
          }
        }
    }
</script>

<style>
  .alipay{
    width: 1390px;
    margin: 0 auto 20px;
  }
  .paysuccessBox{
    width: 100%;
    height: 300px;
    margin: 0 auto;
    border: 1px solid #E9E9E9;
  }
  .paysuccessTitle{
    width: 97.1%;
    height: 70px;
    padding: 0 20px;
  }
  .paysuccessMain{
    width: 100%;
    height: auto;
    margin: 20px auto;
  }
  .successicon{
    display: block;
    width: 40px;
    height: 40px;
    margin: 0 auto;
  }
  .successicon img{
    width: 100%;
    height: 100%;
  }
  .successt{
    display: block;
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 16px;
  }
  .paysuccessFooter{
    width: 230px;
    height: 45px;
    margin: 15px auto;
  }
  .paysuccessFooter div{
    width: 33%;
    height: 100%;
    float: left;
    text-align: center;
    line-height: 45px;
  }
  .paysuccessFooter div:nth-child(1){
    text-align: right;
    cursor: pointer;
  }
  .paysuccessFooter div:nth-child(3){
    text-align: left;
    cursor: pointer;
  }
  .gohome:hover{
    color: #FF6600;
  }
  .gogoodsdetails:hover{
    color: #FF6600;
  }
  .successAddress,.successPrice{
    width: auto;
    height: 35px;
    line-height: 35px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Alipay/alipay.vue